import GameLoader from './components/GameLoader'

function App() {
  return <GameLoader />
}

export default App
